import { render } from "./software-recommend.vue?vue&type=template&id=7efe85be&scoped=true&ts=true"
import script from "./software-recommend.vue?vue&type=script&lang=ts"
export * from "./software-recommend.vue?vue&type=script&lang=ts"

import "./software-recommend.vue?vue&type=style&index=0&id=7efe85be&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efe85be"]])